export default {
  "about": "Over",
  "about_title": "Over Ons",
  "access_secret": "Toegangsgeheim",
  "access_token": "Toegangstoken",
  "accessibility_animations": "Animaties",
  "accessibility_contrast": "Contrast",
  "accessibility_font_size": "Lettergrootte",
  "accessibility_title": "Toegankelijkheid",
  "actions": "Acties",
  "active": "Actief",
  "active_ads": "Actieve Advertenties",
  "active_campaigns": "Actieve Campagnes",
  "ad_code_placeholder": "<script>...</script> of AdSense-slotcode",
  "ad_format": "Advertentieformaat",
  "ad_formats": "Advertentieformaten",
  "ad_management": "Advertentiebeheer",
  "ad_position_settings": "Advertentiepositie-instellingen",
  "ad_price_list": "Advertentieprijslijst",
  "ad_pricing_formats_campaigns": "Prijzen, formaten, campagnes en tracking",
  "add": "Toevoegen",
  "add_api_keys": "Voeg API-sleutels toe in het Configuratievenster",
  "address": "Adres",
  "admin": "Admin",
  "adminPanel": "Adminpaneel",
  "admin_ab_testing_title": "A/B-testen",
  "admin_accent": "Accent",
  "admin_accent_color": "Accentkleur",
  "admin_action": "Actie",
  "admin_activate": "Activeren",
  "admin_active_feeds": "Actieve Feeds",
  "admin_active_label": "ACTIEF",
  "admin_active_now": "Nu Actief",
  "admin_active_subscribers": "Actieve Abonnees",
  "admin_ad_performance": "Advertentieprestaties",
  "admin_add_feed": "Feed Toevoegen",
  "admin_add_tag": "Tag toevoegen",
  "admin_admins": "Beheerders",
  "admin_advertisements": "Advertenties",
  "admin_advertiser_email": "E-mailadres adverteerder",
  "admin_advertiser_name": "Naam adverteerder",
  "admin_affiliate_links": "Affiliate Links",
  "admin_ai_content_title": "AI Inhoudsverwerking",
  "admin_ai_prompt_settings": "AI Prompt- en Modelinstellingen",
  "admin_analytics_title": "Analysetools",
  "admin_api_latency": "API Latentie",
  "admin_api_server": "API-server",
  "admin_article_actions": "Acties",
  "admin_article_category": "Categorie",
  "admin_article_published": "Gepubliceerd",
  "admin_article_selector": "Artikelselector (CSS, bijv. artikel.nieuws)",
  "admin_article_views": "Weergaven",
  "admin_articles_count": "Artikelen",
  "admin_articles_title": "Artikelen",
  "admin_author_change_failed": "Auteur wijziging mislukt.",
  "admin_authors_title": "Auteurs",
  "admin_auto": "AUTO",
  "admin_auto_save_draft": "Automatisch opslaan als concept",
  "admin_avg_seo_score": "Gem. SEO Score",
  "admin_bio": "Bio",
  "admin_blog_manage": "Beheer blogberichten met rijke inhoudseditor",
  "admin_blog_title": "Blog",
  "admin_brand_theme": "Merk & Thema",
  "admin_branding_desc": "Uiterlijk van de site aanpassen (alleen systeembeheerder)",
  "admin_branding_title": "Rebranding-module",
  "admin_breaking_ticker": "Breaking News Ticker",
  "admin_browser": "Browser",
  "admin_browsers": "Browsers",
  "admin_bug_reports": "Bugrapporten",
  "admin_bulk_delete_failed": "Bulk verwijderen mislukt.",
  "admin_bulk_operations": "Bulkoperaties",
  "admin_categories_grid": "Categorieën Raster",
  "admin_choose_gallery": "Kies uit Galerie",
  "admin_churn_prediction": "Churn Voorspelling",
  "admin_classic_portal": "Klassiek Nieuwsportaal",
  "admin_classifieds": "Advertenties",
  "admin_clear_log": "Log Wissen",
  "admin_click_button": "Klik op de knop",
  "admin_collection_stats": "Collectie Statistieken",
  "admin_color_scheme": "Kleurschema",
  "admin_columnist": "Columnist",
  "admin_comments": "Opmerkingen",
  "admin_competitor_monitoring": "Concurrentiebewaking",
  "admin_confirm_action": "Weet je het zeker?",
  "admin_content_calendar_title": "Inhoudskalender",
  "admin_content_filter": "Inhoud Filtreren Termen",
  "admin_content_stats": "Inhoud Statistieken",
  "admin_contributor": "Bewerker",
  "admin_coordinates": "Coördinaten",
  "admin_copy_ip": "Kopieer IP-adres",
  "admin_copy_text": "Kopieer",
  "admin_core_services": "Kern Diensten",
  "admin_countries": "Landen",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Nu Crawlen",
  "admin_create_author": "Auteur aanmaken",
  "admin_create_manage_promo": "Promotiecodes maken en beheren",
  "admin_create_voucher": "Voucher maken",
  "admin_custom_meta": "Aangepaste Meta",
  "admin_dashboard_title": "Dashboard",
  "admin_database": "Databank",
  "admin_db_backup": "Database Backup",
  "admin_db_latency": "DB Latentie",
  "admin_db_name": "Databasenaam",
  "admin_db_size": "DB Grootte",
  "admin_default": "STANDAARD",
  "admin_default_language": "Standaardtaal",
  "admin_device": "Apparaat",
  "admin_devices": "Apparaten",
  "admin_discount": "Korting",
  "admin_disk_usage": "Schijfgebruik",
  "admin_docs_api_ref": "API-referentie",
  "admin_docs_download_pdf": "Download PDF",
  "admin_docs_faq": "FAQ",
  "admin_docs_getting_started": "Aan de slag",
  "admin_docs_implemented": "Geïmplementeerd",
  "admin_docs_no_pages": "Nog geen documentatiepagina's",
  "admin_docs_order": "Bestellen",
  "admin_docs_title": "Documentatie",
  "admin_doktor_earnings": "Doktor inkomsten",
  "admin_draft_articles": "Concept Artikelen",
  "admin_dynamic_pricing": "Dynamische Prijzen",
  "admin_edit_in_cms": "Bewerken in CMS",
  "admin_editor_role": "Editor",
  "admin_export_csv": "Exporteer CSV",
  "admin_favicon": "Favicon",
  "admin_feed_crawler": "Feed Crawler",
  "admin_feed_name": "Feed Naam",
  "admin_feed_url": "Feed URL",
  "admin_feeds_title": "RSS Feeds",
  "admin_file": "Bestand",
  "admin_fixed_amount": "Vast bedrag",
  "admin_frozen": "Bevroren",
  "admin_full_name": "Volledige naam",
  "admin_general": "Algemeen",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Cijfer",
  "admin_health_title": "Gezondheidscontrole",
  "admin_high_leads": "Waardevolle Leads",
  "admin_import_title": "Croatia Times Import Platform",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Integraties",
  "admin_job_postings": "Vacatures",
  "admin_joined": "Lid geworden",
  "admin_keywords": "Trefwoorden",
  "admin_landing_title": "Landingspagina's",
  "admin_last_submissions": "Laatste inzendingen",
  "admin_live_analytics": "Live analyse",
  "admin_live_analytics_title": "Live Analysetools",
  "admin_llm_model": "LLM-model",
  "admin_manage_feeds": "Feeds beheren",
  "admin_mass_management": "Massabeheer van artikelen",
  "admin_max_articles": "Max. artikelen",
  "admin_media_storage": "Media Opslag",
  "admin_memory": "Geheugen",
  "admin_menu_manager": "Menubeheer",
  "admin_meta_description": "Meta-beschrijving",
  "admin_monetization_title": "Monetisatie Dashboard",
  "admin_mysql_db": "MySQL-database",
  "admin_mysql_host": "MySQL-host",
  "admin_nav_ab_testing": "A/B-testen",
  "admin_nav_ads": "Advertentiebeheer",
  "admin_nav_ads_report": "Advertentierapport",
  "admin_nav_adsense": "AdSense-instellingen",
  "admin_nav_advanced_analytics": "Geavanceerde Analytics",
  "admin_nav_affiliates": "Affiliate Links",
  "admin_nav_ai_content": "AI-Contentverwerking",
  "admin_nav_amp": "AMP & Google Discover",
  "admin_nav_analytics": "Analytics",
  "admin_nav_analytics_ai": "Analytics & AI",
  "admin_nav_articles": "Artikelen",
  "admin_nav_audit_log": "Auditlogboek",
  "admin_nav_authors": "Auteurs",
  "admin_nav_blog": "Blog",
  "admin_nav_branding": "Rebranding",
  "admin_nav_breaking_news": "Breaking / Flash Nieuws",
  "admin_nav_bulk_operations": "Bulkbewerkingen",
  "admin_nav_categories": "Categorieën",
  "admin_nav_chat_sessions": "Chatsessies",
  "admin_nav_churn_prediction": "Churnvoorspelling",
  "admin_nav_classifieds": "Advertenties",
  "admin_nav_comments": "Opmerkingen",
  "admin_nav_competitor_monitoring": "Concurrenten Monitoring",
  "admin_nav_content": "Inhoud",
  "admin_nav_content_calendar": "Inhoudskalender",
  "admin_nav_county_map": "Provinciekaart",
  "admin_nav_crypto": "Crypto Widget",
  "admin_nav_dashboard": "Dashboard",
  "admin_nav_db_backup": "Database",
  "admin_nav_docs": "Documentatie",
  "admin_nav_doktor_earnings": "Doktor Verdiensten",
  "admin_nav_duplicate_detection": "Duplicaatdetectie",
  "admin_nav_editorial": "Redactie",
  "admin_nav_editorial_workflow": "Redactionele Workflow",
  "admin_nav_email_campaigns": "E-mailcampagnes",
  "admin_nav_feeds": "RSS-feeds",
  "admin_nav_finance": "Financiën",
  "admin_nav_health": "Systeemgezondheid",
  "admin_nav_heatmaps": "Lees-Heatmap",
  "admin_nav_import": "Importeren",
  "admin_nav_invoices": "Facturen",
  "admin_nav_job_ads": "Vacatureadvertenties",
  "admin_nav_landing_pages": "Landingspagina's",
  "admin_nav_live_analytics": "Live Analytics",
  "admin_nav_management": "Beheer",
  "admin_nav_marketing": "Marketing",
  "admin_nav_media": "Media",
  "admin_nav_menu_manager": "Menubeheer",
  "admin_nav_micropayments": "Microbetalingen",
  "admin_nav_monetization": "Monetisatie",
  "admin_nav_newsletter": "Nieuwsbrief",
  "admin_nav_newsletter_digest": "Nieuwsbriefsamenvatting",
  "admin_nav_pages": "Pagina's",
  "admin_nav_payments": "Betalingen",
  "admin_nav_performance_forecast": "Prestatieprognose",
  "admin_nav_photo_verification": "Fotoverificatie",
  "admin_nav_portal_toggle": "Portaalbeheer",
  "admin_nav_portals": "Portalen",
  "admin_nav_pricing": "Prijzen",
  "admin_nav_promo_codes": "Promocodes",
  "admin_nav_push_notifications": "Pushmeldingen",
  "admin_nav_quizzes": "Quizzen",
  "admin_nav_recommendations": "Contentaanbevelingen",
  "admin_nav_reports": "Contentrapporten",
  "admin_nav_sanitization": "Inhoudsanitatie",
  "admin_nav_scheduler": "Inhoudscheduler",
  "admin_nav_security": "Beveiliging",
  "admin_nav_seo_dashboard": "SEO Dashboard",
  "admin_nav_seo_distribution": "SEO & Distributie",
  "admin_nav_series": "Artikelreeksen",
  "admin_nav_settings": "Instellingen",
  "admin_nav_social": "Sociale Media",
  "admin_nav_social_scheduler": "Sociale Planner",
  "admin_nav_sponsored": "Gesponsord",
  "admin_nav_sponsored_marketplace": "Sponsor Marktplaats",
  "admin_nav_subscriptions": "Abonnementen",
  "admin_nav_surveys": "Enquêtes",
  "admin_nav_syndication": "Syndicatie API",
  "admin_nav_system": "Systeem",
  "admin_nav_tips": "Tips / Donaties",
  "admin_nav_translations": "Vertalingen",
  "admin_nav_ugc_review": "Burgerinhoud",
  "admin_nav_users": "Gebruikers",
  "admin_nav_users_subscriptions": "Gebruikers & Abonnementen",
  "admin_nav_versioning": "Versiegeschiedenis",
  "admin_nav_vibeposao": "Times Posao Portal",
  "admin_nav_vouchers": "Vouchers / Kortingen",
  "admin_nav_widgets": "Widgets / Catalogi",
  "admin_new_author_name": "Nieuwe auteursnaam...",
  "admin_new_post": "Nieuw Bericht",
  "admin_no_data": "Geen gegevens beschikbaar",
  "admin_no_icon": "Geen pictogram",
  "admin_no_logo": "Geen logo",
  "admin_no_pending_reports": "Geen lopende rapporten",
  "admin_no_published_articles": "Geen gepubliceerde artikelen gevonden",
  "admin_password_field": "Wachtwoord",
  "admin_performance_forecast": "Prestatievoorspelling",
  "admin_photo_verification": "Fotocontrole",
  "admin_plan": "Plan",
  "admin_platform_audit": "Platform Audit",
  "admin_portal_toggle": "Portaalbeheer",
  "admin_premium_users": "Premiumgebruikers",
  "admin_primary": "Primair",
  "admin_published_articles": "Gepubliceerde Artikelen",
  "admin_published_today": "Vandaag Gepubliceerd",
  "admin_quick_actions": "Snelle acties",
  "admin_recent_articles": "Recente artikelen",
  "admin_role_change_failed": "Mislukt om rol bij te werken.",
  "admin_search_placeholder": "Zoek admin...",
  "admin_secondary": "Secundair",
  "admin_seo_desc": "Inhoud optimalisatie, GSC & sitemap beheer",
  "admin_seo_title": "SEO Dashboard",
  "admin_service_requests": "Serviceraanvragen",
  "admin_set_category": "Categorie instellen",
  "admin_set_featured": "Aanbevolen instellen",
  "admin_settings_saved": "Instellingen opgeslagen",
  "admin_settings_title": "Instellingen",
  "admin_short_desc": "Korte beschrijving",
  "admin_site_identity": "Site-identiteit",
  "admin_site_logo": "Site-logo",
  "admin_site_settings": "Site-instellingen",
  "admin_sponsored_marketplace": "Gesponsorde Marktplaats",
  "admin_sponsored_title": "Gesponsorde artikelen",
  "admin_surveys_title": "Enquêtes",
  "admin_system_status": "Systeemstatus",
  "admin_table_header_actions": "Acties",
  "admin_table_header_date": "Datum",
  "admin_table_header_email": "E-mail",
  "admin_table_header_name": "Naam",
  "admin_table_header_status": "Status",
  "admin_thumbnail_settings_saved": "Miniatuurinstellingen opgeslagen",
  "admin_top_articles_views": "Topartikelen op Weergaven",
  "admin_total_articles": "Totaal aantal artikelen",
  "admin_total_users": "Totaal aantal gebruikers",
  "admin_total_views": "Totaal aantal weergaven",
  "admin_ugc_review": "UGC Beoordeling",
  "admin_username": "Gebruikersnaam",
  "admin_users_title": "Gebruikers",
  "admin_version_history": "Versiegeschiedenis",
  "admin_view_health_report": "Bekijk volledig gezondheidsrapport",
  "admin_write_new_article": "Nieuw artikel schrijven",
  "adsense_client_id": "AdSense Client ID",
  "adsense_enable_disable": "Automatische advertentieweergave in- of uitschakelen",
  "adsense_global_toggle": "AdSense Globale Schakelaar",
  "adsense_script_code": "AdSense Script Code",
  "adsense_settings": "AdSense & Advertentieposities",
  "advertise_contact_sales": "Neem contact op met Verkoop",
  "advertise_get_started": "Begin Nu",
  "advertise_reach_audience": "Bereik ons publiek",
  "advertise_title": "Adverteer met Ons",
  "advertiser": "Adverteerder",
  "advertiser_analytics": "Adverteerder Analytics",
  "advertiser_email": "E-mailadres Adverteerder",
  "advertising": "Reclame",
  "advertising_cookies": "Reclamecookies",
  "affiliate_title": "Affiliate Programma",
  "ago": "geleden",
  "ai_image_prompt": "AI Afbeeldingprompt",
  "all": "Alles",
  "all_categories": "Alle Categorieën",
  "all_jobs": "Alle Banen",
  "all_rights": "Alle rechten voorbehouden",
  "all_status": "Alle Statussen",
  "all_types": "Alle Types",
  "alpha": "Alfa",
  "alreadyHaveAccount": "Heb je al een account?",
  "already_have_account": "Heb je al een account?",
  "analytics": "Analyse",
  "analytics_cookies": "Analysecookies",
  "api_key": "API Sleutel",
  "api_secret": "API Geheime Sleutel",
  "applications": "Sollicitaties",
  "apply": "Toepassen",
  "apply_now": "Solliciteer Nu",
  "approve": "Goedkeuren",
  "approved": "Goedgekeurd",
  "archive": "Archiveren",
  "archived": "Gearchiveerd",
  "article_content": "Artikelinhoud",
  "article_title": "Artikel Titel...",
  "article_views": "Weergaven",
  "author": "Auteur",
  "auto_posting": "Automatisch plaatsen en sociale integraties",
  "auto_share_articles": "Automatisch gedeelde gepubliceerde artikelen op verbonden platforms",
  "avg_ctr": "Gem CTR",
  "back": "Terug",
  "basic": "Basis",
  "be_respectful": "Wees respectvol en beleefd naar andere gebruikers en onderwerpen van de artikelen",
  "beta": "Bèta",
  "book_ad": "Boek Advertentie",
  "booking_details": "Boekingsgegevens",
  "breaking": "BREKEND NIEUWS",
  "bug_description": "Bugbeschrijving",
  "business": "Zaken",
  "business_account_id": "Zakelijk Account-ID",
  "buyer": "Koper",
  "campaign_details": "Campagnedetails",
  "campaigns": "Campagnes",
  "cancel": "Annuleren",
  "caption": "Onderschrift",
  "categories": "Categorieën",
  "category": "Categorie",
  "category_distribution": "Categorieverdeling",
  "category_push_subscribers": "Categorie Push-abonnees",
  "chatbot_placeholder": "Typ een bericht...",
  "chatbot_send": "Verzend",
  "chatbot_title": "Chat Assistent",
  "choose_plan": "Kies Uw Abonnement",
  "city": "Stad",
  "classifieds": "Advertenties",
  "classifieds_title": "Advertenties",
  "clear": "Wissen",
  "click_rate": "Klikratio",
  "click_url": "Klik URL (bestemming)",
  "clicks": "Klikken",
  "client_id": "Cliënt-ID",
  "client_secret": "Cliëntgeheim",
  "close": "Sluiten",
  "code": "Code",
  "commenting_rules": "Reactieregels",
  "comments": "Reacties",
  "companies": "Bedrijven",
  "company": "Bedrijf",
  "compose_social_post": "Maak Sociale Post",
  "configure": "Configureren",
  "configure_position": "Configureer elke positie met een aangepaste bannerafbeelding of advertentiecode",
  "confirm": "Bevestigen",
  "confirm_delete": "Weet je zeker dat je wilt verwijderen?",
  "confirm_password": "Bevestig Wachtwoord",
  "congratulations": "Gefeliciteerd",
  "contact": "Contact",
  "contact_title": "Contact",
  "contact_us": "Neem Contact Met Ons Op",
  "content": "Inhoud",
  "cookies": "Cookies",
  "cookies_title": "Cookiebeleid",
  "copy": "Kopiëren",
  "copyright": "Auteursrecht",
  "copyright_notice": "Auteursrecht",
  "count": "Aantal",
  "country": "Land",
  "cpm": "CPM",
  "create": "Aanmaken",
  "create_first_ad": "Maak uw eerste advertentie",
  "crypto_change_24h": "Verandering in 24u",
  "crypto_market_cap": "Marktkapitalisatie",
  "crypto_price": "Prijs",
  "crypto_widget_title": "Crypto",
  "ctr": "CTR",
  "culture": "Cultuur",
  "current_plan": "Huidig Abonnement",
  "custom_ad_code": "Aangepaste Advertentiecode",
  "custom_banner_url": "Aangepaste Banner-URL",
  "custom_range": "Aangepast bereik",
  "daily_budget": "Dagelijks Budget",
  "daily_performance": "Dagelijkse Prestaties",
  "dark_mode": "Donkere Modus",
  "data_viz_title": "Datavisualisatie",
  "date": "Datum",
  "dating_add_video": "Voeg een korte video toe zodat potentiële matches je beter kunnen leren kennen",
  "dating_block": "Blokkeren",
  "dating_boosts": "Versterkingen",
  "dating_city": "Stad",
  "dating_next": "Volgende",
  "dating_personality_quiz": "Persoonlijkheidsquiz",
  "dating_quiz_completed": "Persoonlijkheidsquiz voltooid",
  "dating_users": "Gebruikers",
  "dating_verify_identity": "Verifieer dat je een echt persoon bent",
  "dating_voice_message": "Spraakbericht",
  "days": "dagen",
  "delete": "Verwijderen",
  "delete_failed": "Verwijderen mislukt.",
  "deleted_successfully": "Succesvol verwijderd",
  "deprecated": "Verouderd",
  "describe_thumbnail": "Beschrijf de miniatuurafbeelding om te genereren...",
  "description": "Beschrijving",
  "deselect_all": "Alles deselecteren",
  "desktop": "Desktop",
  "details": "Details",
  "dimensions": "Afmetingen",
  "disabled": "Uitgeschakeld",
  "dismiss": "Negeren",
  "documentation": "Documentatie",
  "doktor_add_document": "Document Toevoegen",
  "doktor_biography": "Biografie",
  "doktor_birth_date": "Geboortedatum",
  "doktor_chat": "Chat",
  "doktor_control_date": "Controle Datum",
  "doktor_date": "Datum",
  "doktor_diagnosis": "Diagnose",
  "doktor_enter_name_specialization": "Voer naam en ten minste één specialisatie in",
  "doktor_enter_patient_name": "Voer de naam van de patiënt in",
  "doktor_license_number": "Licentienummer",
  "doktor_panel": "Dokter Paneel",
  "doktor_patient_name": "Naam Patiënt",
  "doktor_text_min_chars": "Tekst moet minstens 50 tekens bevatten",
  "doktor_waiting_room": "Wachtruimte",
  "dont_have_account": "Heb je geen account?",
  "download": "Downloaden",
  "draft": "Concept",
  "duplicate": "Dupliceren",
  "duration_days": "Duur (dagen)",
  "economy": "Economie",
  "edit": "Bewerken",
  "electronics": "Elektronica",
  "email": "E-mail",
  "email_address": "E-mailadres",
  "email_campaigns": "E-mailcampagnes",
  "email_clicks": "E-mail Klikken",
  "email_content": "E-mailinhoud...",
  "email_opens": "E-mail Openingen",
  "email_placeholder": "Je e-mailadres",
  "email_subject": "E-mail Onderwerp",
  "employer": "Werkgever",
  "enabled": "Ingeschakeld",
  "end_date": "Einddatum",
  "enter_advertiser_email": "Voer uw adverteerder e-mail in...",
  "enter_email_to_view": "Voer boven uw adverteerder e-mail in om uw campagneprestaties te bekijken",
  "entertainment": "Entertainment",
  "error": "Fout",
  "error_deleting": "Fout bij verwijderen",
  "error_generating_digest": "Fout bij genereren van samenvatting",
  "error_loading": "Fout bij laden",
  "error_saving": "Fout bij opslaan",
  "error_saving_settings": "Fout bij opslaan",
  "error_sending": "Fout bij verzenden",
  "error_uploading": "Fout bij uploaden",
  "error_uploading_photo": "Uploaden van foto mislukt",
  "events_calendar": "Evenementenkalender",
  "excerpt_summary": "Uittreksel / Samenvatting",
  "experimental": "Experimenteel",
  "export": "Exporteren",
  "export_data": "Exporteer Gegevens",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Facebook-login niet beschikbaar",
  "failed_post_comment": "Reactie plaatsen mislukt.",
  "feature_flags": "Functie Vlaggen",
  "feature_job": "Uitgelichte Baan",
  "featured": "Uitgelicht",
  "featured_article": "Uitgelicht Artikel",
  "featured_duration": "Uitgelichte Duur",
  "featured_image": "Uitgelichte Afbeelding",
  "featured_jobs": "Uitgelichte Banen",
  "feedback": "Feedback",
  "filter": "Filter",
  "filter_terms_saved": "Filtertermen opgeslagen!",
  "find_jobs": "Vind Banen",
  "first": "Eerste",
  "first_process_publish": "Eerst het artikel verwerken en publiceren",
  "footer_ai": "Dit portaal maakt gebruik van AI-assistentie om de gebruikerservaring te verbeteren",
  "footer_ai_notice": "Enkele inhoud gemaakt met AI-assistentie - meld problemen",
  "footer_cat_business": "Bedrijf",
  "footer_cat_culture": "Cultuur",
  "footer_cat_health": "Gezondheid",
  "footer_cat_news": "Nieuws",
  "footer_cat_politics": "Politiek",
  "footer_cat_sports": "Sport",
  "footer_cat_technology": "Technologie",
  "footer_categories": "Categorieën",
  "footer_copyright": "2026 Liber Nostra d.o.o. Alle rechten voorbehouden.",
  "footer_description": "Croatia Times is jouw vertrouwde bron voor laatste nieuws, diepgaande analyses en boeiende verhalen uit Kroatië en daarbuiten.",
  "footer_developed_by": "Ontwikkeld en onderhouden met liefde door",
  "footer_email_placeholder": "Je e-mailadres",
  "footer_here": "hier",
  "footer_hosted_by": "Gehost door",
  "footer_link_about": "Over Ons",
  "footer_link_advertise": "Adverteren",
  "footer_link_contact": "Contact",
  "footer_link_cookies": "Cookies",
  "footer_link_imprint": "Colofon",
  "footer_link_privacy": "Privacybeleid",
  "footer_link_submit_news": "Nieuws Indienen",
  "footer_newsletter_text": "Abonneer op onze nieuwsbrief",
  "footer_quick_links": "Snelle links",
  "footer_stay_informed": "Blijf geïnformeerd",
  "footer_subscribe": "Abonneren",
  "for_you_personalized": "Persoonlijke inhoud op basis van uw interesses",
  "for_you_title": "Voor Jou",
  "forgot_password": "Wachtwoord vergeten?",
  "free": "Gratis",
  "free_plan": "Gratis",
  "from": "Van",
  "full_time": "Voltijd",
  "general": "Algemeen",
  "goodbye": "Vaarwel",
  "hashtags": "Hashtags",
  "hashtags_placeholder": "#nieuws #kroatië...",
  "header_auto_schedule_active": "Auto-schema actief",
  "header_forecast": "Voorspelling",
  "header_humidity": "Vochtigheid",
  "header_live": "LIVE",
  "header_portals_label": "Portalen",
  "header_weather_humidity": "Vochtigheid",
  "header_weather_wind": "Wind",
  "header_wind": "Wind",
  "health": "Gezondheid",
  "hello": "Hallo",
  "help": "Hulp",
  "home": "Home",
  "home_podcast_title": "Wekelijkse Technische Samenvatting: AI in Kroatische Startups",
  "home_video_title": "Binnen Zagreb: Straatkunst Documentaire",
  "hours": "uren",
  "import": "Importeren",
  "impressions": "Weergaven",
  "imprint": "Colofon",
  "imprint_title": "Colofon",
  "inactive": "Inactief",
  "info": "Info",
  "instagram": "Instagram",
  "invalid_code": "Ongeldige code. Probeer opnieuw.",
  "items_selected": "items geselecteerd",
  "job_categories": "Baan Categorieën",
  "job_postings": "Vacatures",
  "job_seeker": "Werkzoekende",
  "just_now": "Zojuist",
  "language": "Taal",
  "last": "Laatste",
  "latest_news": "Laatste Nieuws",
  "legal": "Juridisch",
  "lifestyle": "Levensstijl",
  "lifetime": "Levenslang",
  "light_mode": "Lichte Modus",
  "linked_email_campaign": "Gekoppeld aan e-mailcampagne",
  "linkedin": "LinkedIn",
  "live_stream": "Live Stream",
  "load_more": "Meer laden",
  "loading": "Laden...",
  "local": "Lokaal",
  "location": "Locatie",
  "login": "Inloggen",
  "logout": "Uitloggen",
  "loyalty_available_points": "Beschikbare Punten",
  "loyalty_available_rewards": "Beschikbare Beloningen",
  "loyalty_badges": "Badges",
  "loyalty_consecutive_days": "Aaneengesloten Dagen",
  "loyalty_error": "Fout",
  "loyalty_leaderboard": "Ranglijst",
  "loyalty_leaderboard_empty": "Ranglijst is leeg",
  "loyalty_rewards": "Beloningen",
  "loyalty_used_rewards": "Gebruikte Beloningen",
  "majstor_categories": "Categorieën",
  "majstor_city": "Stad",
  "majstor_company_name": "Bedrijfsnaam *",
  "majstor_flexible": "Flexibel",
  "majstor_max_budget": "Maximaal budget (EUR)",
  "majstor_min_budget": "Minimaal budget (EUR)",
  "majstor_my_requests": "Mijn Verzoeken",
  "majstor_request_title": "Verzoek Titel *",
  "majstor_service_categories": "Dienstcategorieën",
  "majstor_urgent": "Dringend",
  "manage": "Beheren",
  "manage_bookings": "Beheer adverteerder boekingen",
  "mark_as_read": "Markeer als gelezen",
  "marketing_dashboard": "Marketing Dashboard",
  "marketing_live_metrics": "Live prestatiestatistieken voor Croatia Times",
  "marketing_published_articles": "Gepubliceerde Artikelen",
  "marketing_registered_users": "Geregistreerde Gebruikers",
  "marketing_today_views": "Weergaven van Vandaag",
  "marketing_total_views": "Totaal Paginaweergaven",
  "minutes": "minuten",
  "missing_translations": "Ontbrekende Vertalingen",
  "mobile": "Mobiel",
  "more": "Meer",
  "most_popular": "Meest Populair",
  "most_read": "Meest Gelezen",
  "move": "Verplaatsen",
  "must_be_logged_in_purchase": "Je moet ingelogd zijn om een artikel te kopen",
  "myProfile": "Mijn Profiel",
  "my_applications": "Mijn Sollicitaties",
  "name": "Naam",
  "new": "Nieuw",
  "new_article": "Nieuw Artikel",
  "new_campaign": "Nieuwe Campagne",
  "new_notification": "Nieuwe Melding",
  "new_push_notification": "Nieuwe Pushmelding",
  "new_verification_sent": "Een nieuwe verificatiecode is naar je e-mail gestuurd.",
  "news": "Nieuws",
  "newsletter": "Nieuwsbrief",
  "newsletter_desc": "Abonneer voor het laatste nieuws",
  "newsletter_only_subscribers": "Alleen abonnees",
  "newsletter_subscribers": "Nieuwsbriefabonnees",
  "next": "Volgende",
  "no": "Nee",
  "noAccount": "Heb je geen account?",
  "no_articles": "Geen artikelen gevonden",
  "no_bookings": "Geen boekingen gevonden",
  "no_campaigns": "Geen campagnes",
  "no_data": "Geen gegevens beschikbaar",
  "no_items": "Geen items gevonden",
  "no_linked_campaign": "Geen gekoppelde campagne",
  "no_notifications": "Geen meldingen",
  "no_results": "Geen resultaten gevonden",
  "no_scheduled_posts": "Nog geen geplande berichten",
  "no_sent_notifications": "Geen verzonden meldingen",
  "none": "Geen",
  "note": "Notitie",
  "notification_body": "Meldingsinhoud",
  "notification_title": "Meldingstitel",
  "notifications": "Meldingen",
  "of": "van",
  "off": "Uit",
  "offline": "Offline",
  "on": "Aan",
  "one_time": "eenmalig",
  "online": "Online",
  "open_rate": "Openingspercentage",
  "optional": "Optioneel",
  "options": "Opties",
  "orContinueWith": "Of ga verder met",
  "or_continue_with": "Of ga verder met",
  "order": "Bestelling",
  "other": "Overige",
  "page": "Pagina",
  "part_time": "Deeltijd",
  "password": "Wachtwoord",
  "paste": "Plakken",
  "pause": "Pauzeren",
  "payment_error": "Betalingsfout",
  "payment_processing": "Betaling wordt verwerkt...",
  "payment_success": "Betaling Succesvol!",
  "payment_thank_you": "Bedankt voor uw aankoop!",
  "pending": "In afwachting",
  "pending_approval": "In afwachting van goedkeuring",
  "per_month": "/maand",
  "per_page": "per pagina",
  "percentage": "Percentage",
  "performance": "Prestaties",
  "phone": "Telefoon",
  "platforms": "Platforms",
  "politics": "Politiek",
  "poll_results": "Resultaten",
  "poll_total_votes": "Totaal aantal stemmen",
  "poll_vote": "Stem",
  "popular": "Populair",
  "post_comment": "Plaats reactie",
  "post_error": "Berichtfout",
  "post_job": "Plaats een Baan",
  "post_now": "Nu Plaatsen",
  "powered_by": "Mogelijk gemaakt door",
  "premium": "Premium",
  "preview": "Voorbeeld",
  "previous": "Vorige",
  "price": "Prijs",
  "privacy": "Privacy",
  "privacy_title": "Privacybeleid",
  "proceed_to_payment": "Doorgaan naar Betaling",
  "profile": "Profiel",
  "profile_admin_access": "Snelle Toegang voor Beheerder",
  "profile_analytics": "Analyse",
  "profile_articles": "Artikelen",
  "profile_dashboard": "Dashboard",
  "profile_edit": "Profiel Bewerken",
  "profile_verified": "Profiel geverifieerd!",
  "promo_success": "Promocode succesvol toegepast!",
  "promote_job": "Promoot Baan",
  "publish": "Publiceren",
  "published": "Gepubliceerd",
  "published_date": "Gepubliceerd",
  "push_notifications": "Pushmeldingen",
  "read": "Gelezen",
  "read_more": "Lees Meer",
  "real_estate": "Vastgoed",
  "recent": "Recent",
  "recipes_add_first": "Voeg je eerste recept toe",
  "recipes_browse_all": "Blader door alle recepten",
  "recipes_category": "Categorie",
  "recipes_cook_time": "Kooktijd",
  "recipes_easy": "Eenvoudig",
  "recipes_featured": "Aanbevolen Recepten",
  "recipes_filters": "Filters",
  "recipes_ingredient": "Ingredient",
  "recipes_ingredients": "Ingrediënten",
  "recipes_instructions": "Instructies",
  "recipes_latest": "Nieuwste Recepten",
  "recipes_most_popular": "Meest Populaire Recepten",
  "recipes_prep_time": "Voorbereidingstijd",
  "recipes_search": "Zoek recepten...",
  "recipes_servings": "Porties",
  "recipes_title": "Recepten",
  "recommended": "Aanbevolen",
  "refresh": "Vernieuwen",
  "region": "Regio",
  "register": "Registreren",
  "reject": "Afwijzen",
  "rejected": "Afgewezen",
  "related_articles": "Gerelateerde Artikelen",
  "remote": "Op Afstand",
  "remove": "Verwijderen",
  "report": "Rapport",
  "reports": "Rapporten",
  "reposting_rules_title": "Regels voor Herplaatsen",
  "required": "Vereist",
  "reset": "Resetten",
  "restore": "Herstellen",
  "results": "Resultaten",
  "resume": "Hervatten",
  "revision_restored": "Revisie hersteld!",
  "salary": "Salaris",
  "salary_max": "Max Salaris",
  "salary_min": "Min Salaris",
  "save": "Opslaan",
  "saved_jobs": "Opgeslagen Banen",
  "saved_successfully": "Succesvol opgeslagen",
  "schedule": "Schema",
  "scheduled": "Gepland",
  "science": "Wetenschap",
  "search": "Zoeken...",
  "search_articles": "Zoek artikelen...",
  "search_placeholder": "Zoeken...",
  "search_results_for": "Zoekresultaten voor",
  "seconds": "seconden",
  "see_all": "Bekijk alles",
  "select": "Selecteren",
  "select_all": "Alles selecteren",
  "select_format": "Selecteer Formaat",
  "seller": "Verkoper",
  "send_campaign": "Campagne Verzenden",
  "sent": "Verzonden",
  "sent_campaigns": "Verzonden Campagnes",
  "services": "Diensten",
  "settings": "Instellingen",
  "share": "Delen",
  "showing": "Toont",
  "signIn": "Inloggen",
  "signOut": "Uitloggen",
  "site_name": "Croatia Times",
  "site_subtitle": "Kroatië Vandaag",
  "six_digit_code": "6-cijferige code",
  "social_media": "Sociale Media",
  "social_scheduler": "Sociale Planner",
  "sort": "Sorteren",
  "sponsored_marketplace_title": "Gesponsorde Marktplaats",
  "sports": "Sport",
  "stable": "Stabiel",
  "start": "Starten",
  "start_date": "Startdatum",
  "static_about_contact": "Voor redactionele vragen, advertenties of algemene informatie, bezoek onze",
  "static_about_contact_page": "contactpagina",
  "static_about_contact_title": "Contact",
  "static_about_lead": "Croatia Times is een onafhankelijk nieuwsportaal dat u het laatste nieuws, analyses, commentaren en verhalen uit Kroatië en de regio brengt. We maken deel uit van de e-mina.eu mediafamilie, met hetzelfde team en dezelfde waarden.",
  "static_about_mission": "We zijn toegewijd aan het leveren van accurate, tijdige en kwaliteitsjournalistiek die het publieke belang dient. Ons redactieteam bestaat uit ervaren journalisten met een diepgaande kennis van Kroatische en regionale aangelegenheden.",
  "static_about_mission_title": "Onze Missie",
  "static_about_publisher": "Liber Nostra d.o.o. is de uitgever van Croatia Times en e-mina.eu. Het bedrijf is gespecialiseerd in digitale media en nieuwsportalen gericht op de Kroatische markt.",
  "static_about_publisher_title": "Uitgever",
  "static_about_standards": "Croatia Times houdt zich aan de hoogste journalistieke normen. We controleren feiten in onze rapportages, labelen commentaar en analyses duidelijk, en corrigeren fouten snel en transparant.",
  "static_about_standards_title": "Redactionele Normen",
  "static_about_team": "Achter Croatia Times staat een team van ervaren mediaprofessionals, journalisten, redacteuren en technische experts die werken aan de platformontwikkeling en inhoudskwaliteit. Ons team is hetzelfde als dat achter het succesvolle portaal e-mina.eu - International News Agency.",
  "static_about_team_title": "Team",
  "static_about_title": "Over Ons - Croatia Times",
  "static_bug_description": "Bugbeschrijving",
  "static_bug_description_placeholder": "Beschrijf wat er gebeurde en hoe het probleem te reproduceren is...",
  "static_bug_intro": "Iets gevonden dat niet correct werkt? Laat het ons weten en we lossen het snel op.",
  "static_bug_page_url": "Pagina-URL (waar de bug optrad)",
  "static_bug_screenshot": "Schermafbeelding (optioneel)",
  "static_bug_submit": "Bugrapport indienen",
  "static_bug_submitting": "Indienen...",
  "static_bug_thanks": "Bedankt voor je melding! We zullen het onderzoeken en het probleem oplossen.",
  "static_bug_title": "Een bug melden",
  "static_commenting_intro": "We verwelkomen constructieve discussies. Om onze sectie voor opmerkingen positief en productief te houden, volg alstublieft deze regels:",
  "static_commenting_login": "Om te reageren, moet u geregistreerd zijn en ingelogd bij Croatia Times.",
  "static_commenting_rule_1": "Wees respectvol en beleefd tegen andere gebruikers en de onderwerpen van de artikelen",
  "static_commenting_rule_2": "Geen haatzaaiende uitlatingen, racisme, seksisme of discriminatie van welke aard dan ook",
  "static_commenting_rule_3": "Geen spam, reclame of promotionele inhoud",
  "static_commenting_rule_4": "Geen desinformatie of verspreiding van onbevestigde claims",
  "static_commenting_rule_5": "Geen persoonlijke aanvallen of intimidatie",
  "static_commenting_rule_6": "Blijf bij het onderwerp en draag bij aan het gesprek",
  "static_commenting_rule_7": "Geen persoonlijke of vertrouwelijke informatie over derden",
  "static_commenting_title": "Commentaarregels",
  "static_commenting_violation": "Opmerkingen die de regels schenden, kunnen zonder kennisgeving worden verwijderd. Herhaalde overtreders kunnen permanent worden verbannen.",
  "static_contact_email": "E-mail",
  "static_contact_message": "Bericht",
  "static_contact_message_placeholder": "Uw bericht...",
  "static_contact_name": "Naam",
  "static_contact_name_placeholder": "Uw naam",
  "static_contact_send": "Bericht Verzenden",
  "static_contact_sending": "Verzenden...",
  "static_contact_sent_desc": "We nemen binnen 24 uur contact met u op.",
  "static_contact_sent_title": "Bericht Verzonden!",
  "static_contact_subject": "Onderwerp",
  "static_contact_subject_placeholder": "Hoe kunnen we helpen?",
  "static_contact_title": "Contacteer Ons",
  "static_cookies_advertising_text": "We kunnen Google AdSense-cookies gebruiken om relevante advertenties te tonen.",
  "static_cookies_advertising_title": "Advertentiecookies",
  "static_cookies_analytics_text": "Google Analytics helpt ons te begrijpen hoe bezoekers onze site gebruiken. Gegevens worden indien mogelijk geanonimiseerd.",
  "static_cookies_analytics_title": "Analysecookies",
  "static_cookies_managing_text": "U kunt cookies beheren via de instellingen van uw browser. Het uitschakelen van noodzakelijke cookies kan de functionaliteit van de site beïnvloeden.",
  "static_cookies_managing_title": "Beheer van Cookies",
  "static_cookies_necessary_text": "Deze zijn vereist voor de werking van de site (inlogsessies, themavoorkeuren). Ze kunnen niet worden uitgeschakeld.",
  "static_cookies_necessary_title": "Noodzakelijke Cookies",
  "static_cookies_title": "Cookiebeleid",
  "static_cookies_types_title": "Soorten Cookies Die We Gebruiken",
  "static_cookies_what_text": "Cookies zijn kleine tekstbestanden die op uw apparaat worden geplaatst wanneer u een website bezoekt. Ze helpen de site om uw voorkeuren te onthouden en te begrijpen hoe u deze gebruikt.",
  "static_cookies_what_title": "Wat Zijn Cookies",
  "static_imprint_ads_email": "E-mail (adverteren):",
  "static_imprint_ai_notice": "Sommige inhoud is gegenereerd met AI-technologie. Meld fouten of ongepaste inhoud aan",
  "static_imprint_contact": "Contact",
  "static_imprint_copyright": "Auteursrecht",
  "static_imprint_copyright_text": "Alle inhoud gepubliceerd op Croatia Times is beschermd door auteursrecht. Liber Nostra d.o.o. behoudt alle rechten op tekst, afbeeldingen en multimedia-inhoud die op deze site worden gepubliceerd. Gedetailleerde informatie over regels voor het herplaatsen van inhoud is beschikbaar op de",
  "static_imprint_ct_desc": "Croatia Times nieuwsportaal",
  "static_imprint_disclaimer": "Disclaimer",
  "static_imprint_disclaimer_text": "Ondanks zorgvuldige inhoudscontrole aanvaarden wij geen verantwoordelijkheid voor externe links. Hun exploitanten zijn uitsluitend verantwoordelijk voor hun inhoud.",
  "static_imprint_editorial_email": "E-mail (redactioneel):",
  "static_imprint_emina_desc": "International News Agency",
  "static_imprint_general_email": "E-mail (algemene vragen):",
  "static_imprint_last_updated": "Laatst bijgewerkt: februari 2026",
  "static_imprint_or_via": "of via onze",
  "static_imprint_publisher": "Uitgever",
  "static_imprint_registered": "Geregistreerd in de Republiek Kroatië",
  "static_imprint_reposting_page": "pagina met regels voor herplaatsing",
  "static_imprint_responsible": "Verantwoordelijk voor Inhoud",
  "static_imprint_responsible_text": "Redactieteam van Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Colofon",
  "static_imprint_websites": "Websites",
  "static_privacy_controller": "Data Verantwoordelijke: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "We gebruiken cookies voor functionaliteit en analyse. Zie ons Cookiebeleid voor details.",
  "static_privacy_cookies_title": "Cookies",
  "static_privacy_data_text": "We verzamelen gegevens die u direct verstrekt (naam, e-mail bij aanmelding), gebruiksgegevens (bezochte pagina's, gelezen artikelen) en technische gegevens (IP-adres, browsertype).",
  "static_privacy_data_title": "Gegevens die we Verzamelen",
  "static_privacy_last_updated": "Laatst bijgewerkt: januari 2026",
  "static_privacy_lead": "Croatia Times respecteert uw privacy en zet zich in voor de bescherming van uw persoonlijke gegevens.",
  "static_privacy_retention_text": "We bewaren uw gegevens zolang uw account actief is, of zolang als nodig is voor juridische doeleinden.",
  "static_privacy_retention_title": "Gegevensbewaring",
  "static_privacy_rights_text": "U heeft het recht om uw persoonlijke gegevens in te zien, te corrigeren of te verwijderen. Neem contact met ons op via",
  "static_privacy_rights_title": "Uw Rechten",
  "static_privacy_title": "Privacybeleid",
  "static_privacy_usage_text": "We gebruiken uw gegevens om onze nieuwsdienst te leveren, uw ervaring te personaliseren, nieuwsbrieven te versturen (met uw toestemming) en ons platform te verbeteren.",
  "static_privacy_usage_title": "Hoe We Uw Gegevens Gebruiken",
  "static_reposting_copyright_text": "Alle inhoud gepubliceerd op Croatia Times is beschermd door auteursrecht. Liber Nostra d.o.o. behoudt zich alle rechten voor op de tekst, afbeeldingen en multimedia die op deze website zijn gepubliceerd.",
  "static_reposting_copyright_title": "Auteursrecht",
  "static_reposting_permission_text": "Voor toestemming om inhoud te herdrukken, neem contact met ons op via",
  "static_reposting_permission_title": "Toestemmingsverzoeken",
  "static_reposting_permitted_text": "U mag links naar onze artikelen delen op sociale media en andere platforms. Korte citaten (tot 2 alinea's) mogen worden gebruikt met duidelijke bronvermelding en een link terug naar het originele artikel.",
  "static_reposting_permitted_title": "Toegestaan Gebruik",
  "static_reposting_prohibited_text": "Volledige herdruk van artikelen zonder schriftelijke toestemming is verboden. Afbeeldingen mogen niet worden gereproduceerd zonder toestemming. Geautomatiseerde inhoudscraping is strikt verboden.",
  "static_reposting_prohibited_title": "Verboden Gebruik",
  "static_reposting_title": "Regels voor Herplaatsen",
  "static_submit_news_details": "Details van het Verhaal",
  "static_submit_news_details_placeholder": "Beschrijf het nieuws...",
  "static_submit_news_file_limit_error": "Bestand overschrijdt de limiet van",
  "static_submit_news_headline": "Nieuws Kop",
  "static_submit_news_intro": "Heeft u nieuws? Stuur het hierheen en ons redactionele team zal het beoordelen.",
  "static_submit_news_limit": "We accepteren foto's en video's tot",
  "static_submit_news_photos": "Foto's / Video (tot",
  "static_submit_news_send": "Nieuws indienen",
  "static_submit_news_sending": "Verzenden...",
  "static_submit_news_source": "Bron / Referentie (optioneel)",
  "static_submit_news_source_placeholder": "URL of referentie",
  "static_submit_news_thanks": "Bedankt voor uw inzending! Ons team zal het spoedig beoordelen.",
  "static_submit_news_title": "Stuur Uw Nieuws In",
  "static_submit_news_your_name": "Uw Naam",
  "status": "Status",
  "stop": "Stoppen",
  "submit": "Indienen",
  "submitNews": "Nieuws Indienen",
  "submit_bug_title": "Bugrapport Indienen",
  "submit_news": "Nieuws Indienen",
  "submit_news_title": "Nieuws Indienen",
  "subscribe": "Abonneren",
  "subscription": "Abonnement",
  "subscription_title": "Abonnementen",
  "success": "Succes",
  "support": "Ondersteuning",
  "tablet": "Tablet",
  "tags": "Tags",
  "target_impressions": "Doel Weergaven",
  "technology": "Technologie",
  "template": "Sjabloon",
  "templates": "Sjablonen",
  "terms": "Voorwaarden",
  "thank_you": "Dank je",
  "this_month": "Deze maand",
  "this_week": "Deze week",
  "this_year": "Dit jaar",
  "tip": "Tip",
  "title": "Titel",
  "to": "Tot",
  "today": "Vandaag",
  "total": "Totaal",
  "translate_all": "Vertaal Alles",
  "translation_status": "Vertaalstatus",
  "translations": "Vertalingen",
  "travel": "Reizen",
  "trending": "Trending",
  "try_again": "Opnieuw proberen",
  "twitter": "Twitter",
  "two_factor_auth": "Twee-factor authenticatie",
  "type": "Type",
  "ugc_submit": "Inhoud Indienen",
  "ugc_title": "Burgerjournalisme Portaal",
  "unique_clicks": "Unieke Klikken",
  "unique_opens": "Unieke Openingen",
  "unknown": "Onbekend",
  "unpublish": "Depubliceren",
  "unread": "Ongelezen",
  "update": "Bijwerken",
  "updated_successfully": "Succesvol bijgewerkt",
  "upgrade": "Upgrade",
  "upload": "Uploaden",
  "users": "Gebruikers",
  "vehicles": "Voertuigen",
  "verification_code_sent": "Verificatiecode verzonden naar je e-mail!",
  "version": "Versie",
  "vibeposao": "Times Posao",
  "view": "Bekijken",
  "view_all": "Bekijk alles",
  "views": "Weergaven",
  "warning": "Waarschuwing",
  "welcome": "Welkom",
  "wish_roles": "Gewenste Rollen",
  "working_hours_saved": "Werktijden bespaard!",
  "world": "Wereld",
  "write_new_article": "Schrijf Nieuw Artikel",
  "yes": "Ja",
  "yesterday": "Gisteren",
  "your_bookings": "Uw Boekingen",
  "youtube": "YouTube"
}
